import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetSpecificRowSubTask = createAsyncThunk(
  "SubTask/GetSpecificRowSubTask",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/SubTask/GetSpecificRowSubTask",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ChangeStatusSubTasks = createAsyncThunk(
  "SubTask/ChangeStatusSubTasks",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/SubTask/ChangeStatusSubTasks",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const CompletionEvaluationApplications = createAsyncThunk(
  "SubTask/CompletionEvaluationApplications",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/SubTask/CompletionEvaluationApplications",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetApplicationInfoBySubTaskId = createAsyncThunk(
  "Evaluator/GetApplicationInfoBySubTaskId",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient("application/json");
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/Evaluator/GetApplicationInfoBySubTaskId",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const SaveSubTaskForEvaluation = createAsyncThunk(
  "SubTask/SaveSubTaskForEvaluation",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient("application/json");
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/SubTask/SaveSubTaskForEvaluation",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const CompletionArbitrationApplications = createAsyncThunk(
  "SubTask/CompletionArbitrationApplications",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient("application/json");
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/SubTask/CompletionArbitrationApplications",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const CompletionOfArbitration = createAsyncThunk(
  "SubTask/CompletionOfArbitration",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient("application/json");
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/SubTask/CompletionOfArbitration",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const SubTask = createSlice({
  name: "SubTask",
  initialState: {
    //------------- GetSpecificRowSubTask ---------------------
    SubTaskById: {},
    loadingSubTaskById: false,
    errorSubTaskById: null,
    //------------- ChangeStatusSubTasks ---------------------
    StatusSubTasks: {},
    loadingStatusSubTasks: false,
    errorStatusSubTasks: null,
    //------------- CompletionEvaluationApplications ---------------------
    CompletEvalApplications: {},
    loadingCompletEvalApplications: false,
    errorCompletEvalApplications: null,
    //------------- GetApplicationInfoBySubTaskId ---------------------
    ApplicationBySubTask: {},
    loadingApplicationBySubTask: false,
    errorApplicationBySubTask: null,
    //------------- SaveSubTaskForEvaluation ---------------------
    SaveEvalSubTask: {},
    loadingSaveEvalSubTask: false,
    errorSaveEvalSubTask: null,
    //------------- CompletionArbitrationApplications  ---------------------
    CompletionOnApplications: {},
    loadingCompletionOnApplications: false,
    errorCompletionOnApplications: null,
    //------------- CompletionOfArbitration  ---------------------
    CompletionOfArbitration: {},
    loadingCompletionOfArbitration: false,
    errorCompletionOfArbitration: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetSpecificRowSubTask.pending, (state, action) => {
        state.loadingSubTaskById = true;
        state.SubTaskById = action.payload;
        state.errorSubTaskById = null;
      })
      .addCase(GetSpecificRowSubTask.fulfilled, (state, action) => {
        state.loadingSubTaskById = false;
        state.SubTaskById = action.payload;
      })
      .addCase(GetSpecificRowSubTask.rejected, (state, action) => {
        state.loadingSubTaskById = false;
        state.SubTaskById = action.payload;
      });
    //---------------------ChangeStatusSubTasks----------------------
    builder
      .addCase(ChangeStatusSubTasks.pending, (state, action) => {
        state.loadingStatusSubTasks = true;
        state.StatusSubTasks = action.payload;
        state.errorStatusSubTasks = null;
      })
      .addCase(ChangeStatusSubTasks.fulfilled, (state, action) => {
        state.loadingStatusSubTasks = false;
        state.StatusSubTasks = action.payload;
      })
      .addCase(ChangeStatusSubTasks.rejected, (state, action) => {
        state.loadingStatusSubTasks = false;
        state.StatusSubTasks = action.payload;
      });
    //---------------------CompletionEvaluationApplications----------------------
    builder
      .addCase(CompletionEvaluationApplications.pending, (state, action) => {
        state.loadingCompletEvalApplications = true;
        state.CompletEvalApplications = action.payload;
        state.errorCompletEvalApplications = null;
      })
      .addCase(CompletionEvaluationApplications.fulfilled, (state, action) => {
        state.loadingCompletEvalApplications = false;
        state.CompletEvalApplications = action.payload;
      })
      .addCase(CompletionEvaluationApplications.rejected, (state, action) => {
        state.loadingCompletEvalApplications = false;
        state.CompletEvalApplications = action.payload;
      });
    //---------------------GetApplicationInfoBySubTaskId----------------------
    builder
      .addCase(GetApplicationInfoBySubTaskId.pending, (state, action) => {
        state.loadingApplicationBySubTask = true;
        state.ApplicationBySubTask = action.payload;
        state.errorApplicationBySubTask = null;
      })
      .addCase(GetApplicationInfoBySubTaskId.fulfilled, (state, action) => {
        state.loadingApplicationBySubTask = false;
        state.ApplicationBySubTask = action.payload;
      })
      .addCase(GetApplicationInfoBySubTaskId.rejected, (state, action) => {
        state.loadingApplicationBySubTask = false;
        state.ApplicationBySubTask = action.payload;
      });
    //---------------------SaveSubTaskForEvaluation----------------------
    builder
      .addCase(SaveSubTaskForEvaluation.pending, (state, action) => {
        state.loadingSaveEvalSubTask = true;
        state.SaveEvalSubTask = action.payload;
        state.errorSaveEvalSubTask = null;
      })
      .addCase(SaveSubTaskForEvaluation.fulfilled, (state, action) => {
        state.loadingSaveEvalSubTask = false;
        state.SaveEvalSubTask = action.payload;
      })
      .addCase(SaveSubTaskForEvaluation.rejected, (state, action) => {
        state.loadingSaveEvalSubTask = false;
        state.SaveEvalSubTask = action.payload;
      });

    //---------------------CompletionArbitrationApplications ----------------------
    builder
      .addCase(CompletionArbitrationApplications.pending, (state, action) => {
        state.loadingCompletionOnApplications = true;
        state.CompletionOnApplications = action.payload;
        state.errorCompletionOnApplications = null;
      })
      .addCase(CompletionArbitrationApplications.fulfilled, (state, action) => {
        state.loadingCompletionOnApplications = false;
        state.CompletionOnApplications = action.payload;
      })
      .addCase(CompletionArbitrationApplications.rejected, (state, action) => {
        state.loadingCompletionOnApplications = false;
        state.CompletionOnApplications = action.payload;
      });

    //---------------------CompletionArbitrationApplications ----------------------
    builder
      .addCase(CompletionOfArbitration.pending, (state, action) => {
        state.loadingCompletionOfArbitration = true;
        state.CompletionOfArbitration = action.payload;
        state.errorCompletionOnApplications = null;
      })
      .addCase(CompletionOfArbitration.fulfilled, (state, action) => {
        state.loadingCompletionOfArbitration = false;
        state.CompletionOfArbitration = action.payload;
      })
      .addCase(CompletionOfArbitration.rejected, (state, action) => {
        state.loadingCompletionOfArbitration = false;
        state.errorCompletionOfArbitration = action.payload;
      });
  },
});

export default SubTask.reducer;
